
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import FlagPicker from '@/components/FlagPicker.vue';
import { Route } from 'vue-router';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { productTag } = api;

@Component({
  components: { FlagPicker },
})
export default class swapOutProductTagForm extends Vue {
  private loading: boolean = false;

  private valid: boolean = false;

  private isEdit: boolean = false;

  private tagId: number = 0;

  private color: any = {};

  private productTypes: Array<{ text: string, value: number}> = [
    { text: '商品', value: 1 },
    { text: '點數', value: 2 },
    { text: '折價券', value: 4 },
  ];

  private form = {
    tagName: '',
    tagColor: '#FF0000',
    productType: 0,
    isVisible: true,
  }

  private get title() {
    return this.isEdit ? '修改' : '新增';
  }

  private setTagId(id: any) {
    this.tagId = id;
  }

  private setIsEdit(status: boolean) {
    this.isEdit = status;
  }

  private rules = {
    tagName: [this.requiredRule('名稱'), this.textMaxLengthRule('名稱', 4)],
    color: [this.requiredRule('顏色')],
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private textMaxLengthRule(column: string, maxLength: number) {
    return (v: any) => v.length <= maxLength || `${column}必須小於或等於${maxLength}`;
  }

  private async cancel() {
    await this.$router.back();
  }

  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      const data = { ...this.form, tagColor: this.color.hex };
      const { status } = this.isEdit
        ? await productTag.edit(this.tagId, data)
        : await productTag.add(data);
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: `${this.title}成功` });
        this.$router.back();
      }
    }
  }

  private async mounted() {
    if (this.isEdit) {
      const { data } = await productTag.get(this.tagId);
      this.form = data;
      this.color.hex = this.form.tagColor;
    }
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: swapOutProductTagForm) => void) => void,
  ) {
    const isEdit = to.name === 'swapOutProductTagEdit';
    await next(async (vm) => {
      if (isEdit) {
        const { tagId } = to.params;
        vm.setIsEdit(isEdit);
        vm.setTagId(tagId);
      }
    });
  }
}
